import { EditUserRoleModal } from 'components';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { User } from 'model'
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { editUserRoles } from 'actions/User';
import { selectCurrentUser, selectCurrentIsLoading, selectAccountId, 
  selectIsSubmitting, selectLoggedUser } from 'selectors';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  editRoles: (user: User) => dispatch(editUserRoles(user)),
});

type SelectedValues = {
  currentUser?: User,
  isLoading: boolean,
  isSubmitting: boolean,
  accountId?: string,
  loggedUser?: User,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  currentUser: selectCurrentUser(),
  isLoading: selectCurrentIsLoading(),
  isSubmitting: selectIsSubmitting(),
  accountId: selectAccountId(),
  loggedUser: selectLoggedUser(),
});


export default connect(mapStateToProps, mapDispatchToProps)(EditUserRoleModal);